<template>
  <div class="qyWxRecord" >
    <el-divider content-position="left">微信记录</el-divider>
    <el-row>
      <el-col :span="6" class="col-box">
        <div class="col-box-head">
          <span>员工(<span class="head-total">{{pageOption.total}}</span>)</span>
        </div>
        <div class="user-items">
          <div class="user-item" v-for="(user, index) in pageData" :key="index">
            <div class="user">{{ user.user_nick }} ({{ user.user_name }})</div>
            <div class="user-wx text-hide" :class="userActive === wx.id ? 'active' : ''" v-for="(wx, wxIndex) in user.wxes" :key="wxIndex" @click="handelGetContact(wx.id, wx.wx_id, wx.user_id)">
              <div class="user-wx-avarar"><el-avatar shape="square" :size="45" fit="cover" :src="wx.head">{{ wx.nick_name ? wx.nick_name.substr(0, 1) : ''}}</el-avatar></div>
              <div class="user-wx-name">
                <div class="user-wx-box">
                  <span>{{ wx.nick_name }}</span>
                </div>
                <div class="user-wx-alias">
                  <span>{{ wx.ower_wx_alias }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="col-box">
        <div class="col-box-head">
          <span>联系人&群组(<span class="head-total">{{contactPageOption.total}}</span>)</span>
          <el-row class="mt-5">
            <el-col :span="24">
              <el-radio-group v-model="contactSearch.isGroup" size="mini" @change="handelContactChange">
                <el-radio-button label="全部"></el-radio-button>
                <el-radio-button label="联系人"></el-radio-button>
                <el-radio-button label="群组"></el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
        <el-row class="contact-items" v-scroll-loading="chatScrollBottom" ref="chatList">
          <div class="contact-item" v-for="(contact, index) in contacts" :key="index">
            <div class="contact-wx" :class="contactActive === contact.contact_wx_id ? 'active' : ''" @click="handelGetMessages(contact.contact_wx_id)">
              <div class="contact-wx-avarar"><el-avatar shape="square" :size="45" fit="cover" :src="contact.head">{{ contact.contact_nick_name ? contact.contact_nick_name.substr(0, 1) : '' }}</el-avatar></div>
              <div class="contact-wx-name">
                <div class="contact-wx-box">
                  <span>{{ contact.contact_nick_name }}</span>
                </div>
                <div class="contact-wx-content">
                  <span>{{ contact.last_chat ? contact.last_chat.content : '' }}</span>
                </div>
              </div>
              <div class="contact-wx-time">
                <div style="padding-top: .12rem">{{ contact.date }}</div>
                <!-- <div><span>群人数:6人</span></div> -->
              </div>
            </div>
          </div>
        </el-row>
      </el-col>
      <el-col :span="12">
        <div>
          <div class="col-box-message-head">
            <span>聊天记录</span>
            <el-row class="mt-5">
              <el-col :span="24">
                <el-radio-group v-model="messageSearch.type" size="mini" @change="handelMessageChange">
                  <el-radio-button label="全部"></el-radio-button>
                  <el-radio-button :label="1">文本</el-radio-button>
                  <el-radio-button :label="3">图片</el-radio-button>
                  <el-radio-button :label="496">文件</el-radio-button>
                  <el-radio-button :label="43">视频</el-radio-button>
                  <el-radio-button :label="34">语音</el-radio-button>
                  <el-radio-button :label="48">定位</el-radio-button>
                  <el-radio-button :label="495">链接</el-radio-button>
                  <el-radio-button :label="4933">小程序</el-radio-button>
                  <el-radio-button :label="436207665">红包</el-radio-button>
                  <el-radio-button :label="419430449">转账</el-radio-button>
                  <el-radio-button :label="50">语音视频聊天</el-radio-button>
                  <el-radio-button :label="42">名片</el-radio-button>
                  <el-radio-button :label="855638065">群直播</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
          <div class="chat_content">
            <el-row class="chat_record_wrap" v-scroll-loading="scrollBottom" ref="messagesList">
              <div class="record_item" :class="message.message_type ? 'sender_item' : ''" v-for="(message, index) in messages" :key="index">
                <div class="record_user_head">
                  <el-avatar shape="square" :size="45" fit="cover" :src="msgHead(message)">{{ msgAvatarDeflut(message) }}</el-avatar>
                </div>
                <div class="record_content ml-10">
                  <div class="record_usernick">{{ msgNickName(message) }}</div>
                  <div class="record_wrap">
                    <div class="record p-10" :class="message.message_type ? 'sender' : 'reciver'">
                      <div v-if="message.type === 1" class="recordText">{{ message.content }}</div>
                      <div v-else-if="message.type === 3" class="recordText">
                        <el-image v-if="message.file_url" style="width: 250px" :src="message.file_url" :preview-src-list="[message.file_url]"></el-image>
                        <el-image v-else style="width: 250px" :src="imgDefultSrc"></el-image>
                      </div>
                      <div v-else-if="message.type === 496">
                        <div v-if="message.file_url" class="file_warp" @click="loadFile(message.file_url, message.file_name)">
                          <div class="file_title">
                            <div class="file_text">{{ message.file_name }}</div>
                            <div class="file_sign"><i class="el-icon-document"></i></div>
                          </div>
                          <i class="file_download el-icon-download"></i>
                        </div>
                        <span v-else><i class="el-icon-loading"></i></span>
                      </div>
                      <div v-else-if="message.type === 47" class="recordText">
                        <el-image v-if="message.link_url" style="width: 250px" :src="message.link_url" :preview-src-list="[message.file_url]"></el-image>
                        <span v-else><i class="el-icon-loading"></i></span>
                      </div>
                      <div v-else-if="message.type === 43" class="recordText">
                        <div v-if="message.file_url">
                          <video class="news_video" controls="controls" :src="message.file_url" type="video/mp4"></video>
                        </div>
                        <span v-else><i class="el-icon-loading"></i></span>
                      </div>
                      <div v-else-if="message.type === 34" class="recordText">
                        <div class="record" v-if="message.file_url">
                          <audio controls="controls" :src="message.file_url" type="audio/mp3"></audio>
                        </div>
                        <span v-else><i class="el-icon-loading"></i></span>
                      </div>
                      <div v-else-if="message.type === 48" class="recordText">定位</div>
                      <div v-else-if="message.type === 495" class="recordText">链接</div>
                      <div v-else-if="message.type === 4933" class="recordText">小程序</div>
                      <div v-else-if="message.type === 436207665" class="recordText">红包</div>
                      <div v-else-if="message.type === 419430449" class="recordText">转账</div>
                      <div v-else-if="message.type === 50" class="recordText">语音视频聊天</div>
                      <div v-else-if="message.type === 42" class="recordText">名片</div>
                      <div v-else-if="message.type === 855638065" class="recordText">群直播</div>
                    </div>
                  </div>
                  <div class="record_time">{{ message.message_time }}</div>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'QyWxRecord',
  data () {
    return {

      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示条数
      },
      userActive: null,
      userActiveWxId: null,
      selectUserId: null,
      contacts: [],
      contactPageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      contactSearch: {
        isGroup: '全部'
      },
      contactLoading: false,
      contactComplete: false,
      contactActive: null,
      messages: [],
      messagePageOptin: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      messageSearch: {
        type: '全部'
      },
      messageLoading: false,
      messageComplete: false,
      messageOldHeight: 0,
      messageToBottom: true,
      imgDefultSrc: '/static/qykj/img/qy_wx_def.png'
    }
  },
  computed: {
    contactSearchStr: function () {
      let str = ''
      for (let key in this.contactSearch) {
        str += '&' + key + '=' + this.contactSearch[key]
      }

      return str
    },
    messageSearchStr: function () {
      let str = ''
      for (let key in this.messageSearch) {
        str += '&' + key + '=' + this.messageSearch[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    getUsers () {
      this.$axios.get('/api/admin/qy_users')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.users.data
            this.pageOption.total = data.data.users.total
          }
        })
    },
    handelGetContact (id, wxId, userId) {
      this.userActive = id
      this.userActiveWxId = wxId
      this.selectUserId = userId
      this.contactActive = null
      this.contacts = []
      this.contactActive = null
      this.contactPageOption.currentPage = 1
      this.messagePageOptin.total = 0
      this.contactLoading = false
      this.contactComplete = false
      this.messages = []
      this.getContact()
    },
    getContact () {
      this.$axios.post('/api/admin/qy_wx_msg/recent/' + this.userActiveWxId + '?page=' + this.contactPageOption.currentPage + this.contactSearchStr, {userId: this.selectUserId})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.contacts.push(...data.data.contacts.data)
            this.contactPageOption.total = data.data.contacts.total
            this.getContactLastChat(data.data.contacts.data)
            this.contactLoading = true
            this.contactComplete = data.data.contacts.data.length === 0
          }
        })
    },
    getContactLastChat (contacts) {
      if (contacts.length <= 0) return
      let contactIds = []
      for (var i = 0; i < contacts.length; i++) {
        contactIds.push(contacts[i].get_msg_id)
      }

      this.$axios.post('/api/admin/qy_wx_msg/contact/last', {contactIds: contactIds}, {loadingClose: true})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            for (let i = 0; i < data.data.length; i++) {
              for (let j = 0; j < this.contacts.length; j++) {
                if (this.contacts[j].get_msg_id === data.data[i].get_msg_id) {
                  this.contacts[j].last_chat = data.data[i]
                }
              }
            }
          }
        })
    },
    handelContactChange (val) {
      if (!this.userActiveWxId) return
      this.contactActive = null
      this.contacts = []
      this.contactActive = null
      this.contactPageOption.currentPage = 1
      this.messagePageOptin.total = 0
      this.contactLoading = false
      this.contactComplete = false
      this.messages = []
      this.getContact()
    },
    handelGetMessages (contactWxId) {
      this.contactActive = contactWxId
      this.messagePageOptin.currentPage = 1
      this.messageToBottom = true
      this.getContactMessage(contactWxId, false)
    },
    getContactMessage (contactWxId, isScroll) {
      isScroll = isScroll || false
      if (isScroll) this.oldHeight = this.$refs.messagesList.$el.scrollHeight

      this.$axios.get('/api/admin/qy_wx_msg/contact/' + contactWxId + '/' + this.userActiveWxId + '?page=' + this.messagePageOptin.currentPage + this.messageSearchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            if (isScroll) {
              this.messages.unshift(...data.data.messages)
            } else {
              this.messages = data.data.messages
            }
            if (this.messagePageOptin.currentPage === 1) this.messageLoading = true

            if (this.messageToBottom) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.$refs.messagesList.$el.scrollTop = this.$refs.messagesList.$el.scrollHeight
                }, 500)
              })
            }

            this.messageComplete = data.data.messages.length === 0
          }
        })
    },
    handelMessageChange (val) {
      if (!this.contactActive) return
      this.messagePageOptin.currentPage = 1
      this.messageToBottom = true
      this.getContactMessage(this.contactActive, false)
    },
    chatScrollBottom () {
      let scrollTop = this.$refs.chatList.$el.scrollTop
      let height = this.$refs.chatList.$el.scrollHeight
      let clientHeight = this.$refs.chatList.$el.clientHeight

      if (scrollTop + clientHeight === height && this.contactLoading) {
        if (!this.contactComplete) this.contactPageOption.currentPage++
        this.getContact()
      }

      this.chatLoading = true
    },
    scrollBottom () {
      let scrollTop = this.$refs.messagesList.$el.scrollTop

      if (scrollTop === 0 && this.messageLoading) {
        if (!this.messageComplete) this.messagePageOptin.currentPage++
        this.messageToBottom = false
        this.getContactMessage(this.contactActive, true)
        setTimeout(() => {
          let newHeight = this.$refs.messagesList.$el.scrollHeight
          this.$refs.messagesList.$el.scrollTop = newHeight - this.oldHeight
        }, 500)
      }
    },
    msgHead (msg) {
      let head = ''
      if (msg.is_group) {
        head = msg.message_type ? msg.owner_head : msg.group_user_wx_head
      } else {
        head = msg.message_type ? msg.owner_head : msg.head
      }

      return head
    },
    msgAvatarDeflut (msg) {
      let str = ''
      if (msg.is_group) {
        str = msg.message_type ? msg.owner_nick_name : msg.group_user_wx_nick_name
      } else {
        str = msg.message_type ? msg.owner_nick_name : msg.contact_nick_name
      }

      return str ? str.substr(0, 1) : str
    },
    msgNickName (msg) {
      let nickName = ''
      if (msg.is_group) {
        nickName = msg.message_type ? msg.owner_nick_name : msg.group_user_wx_nick_name
      } else {
        nickName = msg.message_type ? msg.owner_nick_name : msg.contact_nick_name
      }

      return nickName
    },
    loadFile (url, name) {
      window.open(url)
      // this.$axios.get(url, {responseType: 'blob'})
      //   .then((res) => {
      //     let objectUrl = window.URL.createObjectURL(res.data)
      //     let link = document.createElement('a')
      //     link.href = objectUrl
      //     link.download = name
      //     link.click()
      //     setTimeout(function () {
      //       window.URL.revokeObjectURL(objectUrl)
      //     }, 100)
      //   })
    }
  },
  mounted () {
    this.getUsers()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .qyWxRecord
    marginLeft()
    .mt-5
      margin-top: .1rem
    .ml-10
      margin-left: .2rem
    .p-10
      padding: .2rem
    .text-hide
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .active
      background: #eaeaea
    .col-box
      min-height: calc(100vh - 210px)
      border-right: 1px solid rgb(235, 235, 235)
    .col-box-head
      height: 1rem
      padding: 0 .2rem
      overflow: hidden
      .head-total
        color: red
    .col-box-message-head
      height: 2rem
      padding: 0 .2rem
      overflow: hidden
    .user-items
      min-height: calc(100vh - 210px)
      height: 6rem
      overflow-y: auto
    .user-item
      border-bottom: 1px solid rgb(235, 235, 235)
      .user
        padding: .2rem
      .user-wx:hover
        background: #f5f5f5
      .user-wx
        padding: 0 .2rem
        cursor: pointer
        .user-wx-avarar
          display: inline-block
        .user-wx-name
          display: inline-block
          vertical-align: super
      .user-wx-box
        display: flex
        align-items: center
        min-height: .4rem
        color: #444
      .user-wx-alias
        display: flex
        align-items: center
        color: #888
        min-height: .4rem
    .contact-items
      min-height: calc(100vh - 210px)
      height: 6rem
      overflow-y: auto
    .contact-item
      border-bottom: 1px solid rgb(235, 235, 235)
      .contact-wx:hover
        background: #f5f5f5
      .contact-wx
        display: flex
        justify-content: flex-start
        padding: 0 .2rem
        cursor: pointer
        .contact-wx-avarar
          display: inline-block
        .contact-wx-name
          flex: 1
          position: relative
          margin-left: .1rem
          .contact-wx-box
            font-size: .28rem
            width: 100%
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            position: absolute
            top: .12rem
            left: 0
          .contact-wx-content
            width: 100%
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            position: absolute
            bottom: .16rem
            left: 0
            color: #888
            font-size: .24rem
        .contact-wx-time
          font-size: .24rem
          width: 80px
          text-align: right
          color: #555
    .chat_content
      width: 100%
      min-height: calc(100vh - 260px)
      height: 6rem
      overflow: auto
      .chat_record_wrap
        height: 100%
        overflow: auto
        .record_item
          display: flex
          justify-content: flex-start
          padding: .2rem
          .record_wrap
            display: flex
            align-items: center
            .reciver
              background: #e5eeea
            .sender
              background: #9eea6a
            .record
              margin-top: .06rem
              display: inline-block
          .record_time
            color: #888
            line-height: 1.5
        .sender_item
          justify-content: flex-end
        .sender_item .record_wrap
          flex-direction: row-reverse
        .sender_item>.record_user_head
          order: 1
          margin-left: .2rem
        .sender_item .record_time, .sender_item .record_usernick, .sender_item>.record_time
          text-align: right
    .recordText
      overflow: hidden
      text-overflow: ellipsis
      word-break: break-word
      line-height: 1.5
      color: #555
    .file_warp
      width: 200px
      background: #fff
      border-radius: 3px
      cursor: pointer
    .file_title
      display: flex
      -webkit-box-pack: justify
      justify-content: space-between
      padding: .1rem
      border-bottom: 1px solid #ebebeb
    .file_text
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      max-width: 3rem
    .file_sign
      font-size: .6rem
      line-height: .6rem
    .file_download
      display: block
      text-align: right
      padding: 0 .2rem
      font-size: .32rem
      line-height: 1.5
    .news_video
      max-width: 4rem
</style>



// WEBPACK FOOTER //
// src/pages/qykj/QyWxRecord.vue